import { useState } from 'react'

import { useMutation } from 'providers/tanstack-query/useMutation'
import { useSnackbar } from '../useSnackbar'
import { UPDATE_WORKSPACE_PREBID_MODULE_ENABLED } from './api/mutation'
import { Data, Variables } from './api/types'
import {
  UseUpdateWorkspacePrebidModuleEnabled,
  UseUpdateWorkspacePrebidModuleEnabledProps,
} from './types'

export const useUpdateWorkspacePrebidModuleEnabled = ({
  id,
  initialChecked,
  prebidModuleName,
}: UseUpdateWorkspacePrebidModuleEnabledProps): UseUpdateWorkspacePrebidModuleEnabled => {
  const { snackbar } = useSnackbar(prebidModuleName)
  const [checked, setChecked] = useState<boolean>(initialChecked)

  const { mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: UPDATE_WORKSPACE_PREBID_MODULE_ENABLED,
    onCompleted: async (data: Data, variables): Promise<void> => {
      const { errors } = data.updateWorkspacePrebidModuleEnabled
      const value = variables.input.enabled

      if (errors && errors.length > 0) {
        snackbar(value, 'error')
      } else {
        setChecked(value)
        snackbar(value)
      }
    },
  })

  const update = async (event: React.ChangeEvent<HTMLInputElement>): Promise<void> => {
    const value: boolean = event.target.checked

    await mutateAsync({ input: { enabled: value, id } })
  }

  return { checked, update }
}
